import React from "react";
import "./conclave css files/aboutconclave.css";
const design4 = require("../../assets/conclave assets/red_dots.png");
const profile_img_1 = require("../../assets/conclave assets/Amitabh-Kant.png");
const design5 = require("../../assets/conclave assets/gray_dots.png");
const design_6 = require("../../assets/conclave assets/yellow_dots.png");
const profile_2 = require("../../assets/conclave assets/ved_mani.png");
const profile_img_conclave = require("../../assets/conclave assets/Anil_Sahasrabudhe.png");
const profile_img_conclave1 = require("../../assets/conclave assets/Biswajit_Saha.png");
const profile_img_conclave2 = require("../../assets/conclave assets/M._P_-Poonia.png");
const img_speaker = require("../../assets/conclave assets/special_speaker.png");

function AboutConclave(props) {
  return (
    <>
      <section className="about_conclave_main_container">
        <div className="about_under_conclave_main_container">
          <div className="design3_container">
            <img src={design4} alt="design4" />
          </div>
          <p className="title_text_about_conclave">
            ABOUT <br /> THE CONCLAVE
          </p>

          <p className="extra_text_about_conclave_text">
            Crisis requires society to renew itself, albeit in a disruptive way.
            The current Covid-19 pandemic is transforming ways of working,
            living, and relating to each other on a global level dramatically.
            Education will never be the same and the Future of Global Education
            is in the process of going through its most radical changes. <br />
            <br /> That's why DWEC is hosting a Conclave focussing on the field
            of higher education as it goes through this transformation from the
            perspective of all stakeholders namely Government's Education
            Regulatory bodies as well as Indian Institutions including Schools
            Colleges & Universities. <br />
            <br /> The conclave is also going to focus through panel discussions
            on how to transform today's youth into a global talent and make them
            work place ready. <br />
            <br /> Our current Education policy has also highlighted pondering
            on accepting a global policy that will showcase India as a global
            knowledge hub and our Indian youths as a global talent. <br />
            <br /> Come and be a part of this grand Education extravaganza.
          </p>
        </div>
      </section>

      <div className="triangle_shape_container" id="speaker">
        <div className="triangle_under_shape_container">
          <div className="first_main_profile_container">
            <div className="first_profile_container">
              <div className="design_name_title_text_container">
                <div className="design3_container">
                  <img src={design4} alt="design4" />
                </div>
                <p className="amitabh_text">Mr. Amitabh Kant</p>
                <p className="amitabh_text_one">
                  Chief Executive Officer, NITI Aayog{" "}
                </p>
                <p className="amitabh_text_two">Chief Guest</p>
              </div>
              <div className="img_and_dot_img_container">
                <div className="img_profile_container">
                  <img loading="lazy" src={profile_img_1} alt="profile_img" />
                </div>
                <img
                  loading="lazy"
                  className="design_5_img"
                  src={design5}
                  alt="design_"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg_blue_container">
        <div className="sec_profile_container">
          <div className="profile_sec_img_container">
            <div className="sec_photo_container">
              <img src={profile_2} alt="photo_2" loading="lazy" />
            </div>
          </div>
          <div className="content_profile_two_container">
            <div className="design_6_container">
              <img src={design_6} alt="design_6" />
            </div>
            <div className="content_all_text_sec_profile_container">
              <strong className="sec_profile_title_text">
                Mr. Ved Mani Tiwari
              </strong>
              <p className="sec_profile_extra_content">
                <span className="highlight_coo_text">COO</span>, National Skill{" "}
                <br /> Development Corporation
                <br /> (NSDC) -
                <strong className="yellow_highlight_text">
                  Guest of Honour
                </strong>
              </p>
            </div>
          </div>
        </div>
        <div className="speaker_img_main_container">
          <div className="speaker_img_container">
            <img src={img_speaker} alt="speaker_img" />
          </div>
        </div>

        <div className="three_conclave_profile_container">
          <div className="three_under_conclave_profile_container">
            <div className="one_conclave_profile_container">
              <div className="one_conclave_profile_img_container">
                <img
                  src={profile_img_conclave}
                  alt="one_profile_conclave"
                  loading="lazy"
                />
              </div>
              <div className="conclave_profile_content_container">
                <p className="conclave_content_text">
                  <strong className="conclave_name_profile_text">
                    {" "}
                    Prof Anil D. Sahasrabudhe{" "}
                  </strong>
                  <br /> Chairman, AICTE <br />{" "}
                  <span className="extra_conclave_text">
                    {" "}
                    (All India Council for Technical Education)
                  </span>
                </p>
              </div>
            </div>

            <div className="sec_conclave_profile_container">
              <div className="one_conclave_profile_img_container">
                <img
                  src={profile_img_conclave1}
                  alt="one_profile_conclave"
                  loading="lazy"
                />
              </div>
              <div className="conclave_profile_content_container">
                <p className="conclave_content_text">
                  <strong className="conclave_name_profile_text">
                    Dr. Biswajit Saha
                  </strong>
                  <br /> Director, CBSE <br />{" "}
                  <span className="extra_conclave_text">
                    Ministry of Education Govt of India
                  </span>
                </p>
              </div>
            </div>

            <div className="one_conclave_profile_container">
              <div className="one_conclave_profile_img_container">
                <img
                  src={profile_img_conclave2}
                  alt="one_profile_conclave"
                  loading="lazy"
                />
              </div>
              <div className="conclave_profile_content_container">
                <p className="conclave_content_text">
                  <strong className="conclave_name_profile_text">
                    Dr. M. P. Poonia
                  </strong>
                  <br /> Vice Chairman, AICTE <br />{" "}
                  <span className="extra_conclave_text">
                    (All India Council for Technical Education)
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AboutConclave;
